import { Slot } from '@radix-ui/react-slot';
import type { ComponentPropsWithoutRef } from 'react';
import { cn } from '@discover-lib/utils';
import { chipVariants, type ChipVariantProps } from './variants';

export type ChipProps = ComponentPropsWithoutRef<'span'> &
  ChipVariantProps & {
    asChild?: boolean;
  };

/**
 * Inline “chip” UI: compact pill with muted background and small type, meant for metadata such as fee or loyalty points alongside an optional leading icon.
 *
 * Use **`interactive`** when the chip should read as clickable (e.g. hover) on top of `asChild` + `<Link>` or `<button>`.
 */
export default function Chip({ className, asChild = false, interactive, ...props }: ChipProps) {
  const Comp = asChild ? Slot : 'span';

  return <Comp className={cn(chipVariants({ interactive }), className)} {...props} />;
}
